import { CONTACT_EMAIL } from '../../common/lang/en-US';
export const privacyPolicyData = {
    lastUpdated: '2025-02-15',
    sections: [
        {
            content: [
                {
                    description:
                        'We collect personal details that help us identify and communicate with you. This includes:',
                    items: [
                        'Your full name, email address, phone number, and home or work address, which are necessary for account creation and customer support.',
                        'Employment details such as company name, job title, and department to personalize your experience when using our business-related features.',
                        'Login credentials, passwords, and authentication tokens to keep your account secure and facilitate seamless access to our services.',
                        'Profile pictures and avatars that allow you to personalize your account and enhance social interaction.',
                        'Billing information, including credit card details and invoice addresses, required for processing payments and providing receipts.',
                        'Your preferred communication methods and language settings to customize notifications and support responses.',
                    ],
                    title: 'Personal Information',
                },
                {
                    description: 'To optimize your experience, we collect system and device information, such as:',
                    items: [
                        'Device type, operating system, browser version, and other technical details that help us ensure compatibility and troubleshoot issues.',
                        'IP address and geolocation data, which are used to enhance security and detect unauthorized access.',
                        'Usage logs, including interactions with features and navigation patterns, allowing us to improve functionality and user experience.',
                        'System performance metrics and error logs, which help us diagnose and fix technical problems in a timely manner.',
                        'API calls and integration data, ensuring smooth operation when connecting with third-party applications.',
                    ],
                    title: 'Technical Information',
                },
            ],
            id: 'info-we-collect',
            introduction:
                'To provide you with a seamless experience, we collect different types of information that help us improve our services and ensure platform security.',
            title: 'Information We Collect',
        },
        {
            content: [
                {
                    items: [
                        'We use your personal details to create and manage your account, allowing you to access our platform securely.',
                        'Billing details are used to process payments and generate invoices for your transactions.',
                        'Support interactions help us resolve technical issues and respond to inquiries effectively.',
                        'User preferences and settings are stored to customize your experience and ensure continuity across sessions.',
                    ],
                    title: 'Service Provision',
                },
                {
                    items: [
                        'Analyzing feature usage helps us develop new tools and enhance existing functionality.',
                        'Error logs and performance metrics allow us to identify and fix system bugs efficiently.',
                        'User feedback and behavioral insights are utilized to optimize our interface and workflows.',
                        'Research and analytics efforts enable us to introduce innovative solutions based on user needs.',
                    ],
                    title: 'Product Improvement',
                },
            ],
            id: 'how-we-use-information',
            introduction:
                'The data we collect is used to enhance our services, improve security, and provide you with a personalized experience.',
            title: 'How We Use Your Information',
        },
        {
            content: [
                {
                    items: [
                        'End-to-end encryption safeguards data during transmission, ensuring that your information remains private.',
                        'Regular security audits and penetration tests help us identify vulnerabilities and enhance our defenses.',
                        'Multi-factor authentication adds an extra layer of protection to prevent unauthorized access.',
                        'Automated threat detection mechanisms monitor for suspicious activity in real time.',
                        'Routine backups and disaster recovery protocols ensure data integrity and availability.',
                    ],
                    title: 'Technical Security',
                },
            ],
            id: 'data-security',
            introduction:
                'We implement robust security measures to protect your data against unauthorized access, loss, or misuse.',
            title: 'Data Security',
        },
        {
            content: [
                {
                    description: 'You can request a copy of the personal data we store about you.',
                    items: [
                        'Download your data through our self-service portal.',
                        'Request additional information regarding data processing.',
                        'Verify the types of information we hold about you.',
                        'Review data-sharing practices and opt out if necessary.',
                    ],
                    title: 'Access',
                },
                {
                    description: 'If your data is inaccurate or incomplete, you can update it.',
                    items: [
                        'Modify your profile details directly in your account settings.',
                        'Submit correction requests for incorrect personal information.',
                        'Update preferences for notifications and marketing communications.',
                        'Adjust security settings to match your needs.',
                    ],
                    title: 'Correction',
                },
                {
                    description: 'You can request the removal of your personal data from our platform.',
                    items: [
                        'Delete specific data elements from your profile.',
                        'Request complete account deletion, subject to legal obligations.',
                        'Erase historical usage data from our records.',
                        'Withdraw consent for data processing where applicable.',
                    ],
                    title: 'Deletion',
                },
            ],
            id: 'your-rights',
            introduction: 'You have control over how your data is used. Here are your rights:',
            title: 'Your Rights and Choices',
        },
        {
            content: [
                {
                    items: ['Response time : Within 48 hours'],
                },
            ],
            id: 'contact-us',
            introduction:
                'If you have any questions about our privacy policy or data handling practices, please reach out using the following methods:',
            link: `mailto:${CONTACT_EMAIL}`,
            method: 'Email',
            title: 'Contact Us',
            value: CONTACT_EMAIL,
        },
    ],
};
